import { createFileRoute } from '@tanstack/react-router';
import { Appointments } from '@/components/Appointments/Appointments';

export const Route = createFileRoute('/dev/Appointments')({
  component: RouteComponent,
});

function RouteComponent() {
  return <Appointments />;
}
